import Pristine from 'pristinejs';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export default {
    init() {
        let register_modal = document.getElementById('register-modal');
        if(register_modal) {
            //if we are on the network page, lock the scroll unless the user is logged in.
            if($('body').hasClass('page-id-668')) {
                this.lock_scroll();
            }
            
            register_modal.addEventListener('click', function(e) {
                if(e.target === this) {
                    location.href = window.location.origin;
                }
            })

            //hopefully preventing page moving on iOS.
            document.ontouchmove = function(e){
                e.preventDefault();
            }
            
            let modal_inputs = register_modal.querySelectorAll('input');
            if(modal_inputs) {
                for(let i = 0; i < modal_inputs.length; i++) {
                    modal_inputs[i].onfocus = function () {
                        window.scrollTo(0, 0);
                        document.body.scrollTop = 0;
                    }
                }
            }
        }


        let login_button = document.getElementById('login-btn');
        //inital screen
        let stage_0 = document.getElementById('stage-0');
        let login = document.getElementById('login');
        let forgot_password = document.getElementById('forgot-password');
        let password_sent = document.getElementById('password-sent');

        let forgot_password_button = document.getElementById('forgot-password-btn');
        let back_to_register_button = document.getElementById('back-to-register-button');
        let reset_password_button = document.getElementById('reset-password-btn');
        let back_to_login_button = document.getElementById('back-to-login-btn');
        let password_sent_button = document.getElementById('password-sent-btn');

        if(login_button) {
            login_button.addEventListener('click', (e) => {
                e.preventDefault();
                this.swap_views(stage_0, login)
            });
        }

        if(forgot_password_button) {
            forgot_password_button.addEventListener('click', (e) => {
                e.preventDefault();
                this.swap_views(login, forgot_password)
            });
        }

        if(back_to_register_button) {
            back_to_register_button.addEventListener('click', (e) => { 
                e.preventDefault();
                this.swap_views(login, stage_0);
            });
        }

        if(reset_password_button) {
            let reset_password_pristine = new Pristine(document.getElementById('forgot_password_form'), {
                classTo: 'registration-input',
                errorClass: 'invalid',
                successClass: 'valid',
                errorTextParent: 'registration-input',
                errorTextTag: 'p',
                errorTextClass: 'registration-input__validation'
            }, false)

            let that = this;
            reset_password_button.addEventListener('click', (e) => {
                e.preventDefault();
                that.deactivate_button(reset_password_button);
                let validate = reset_password_pristine.validate();
                if(validate) {
                    // this.swap_views(forgot_password, password_sent) 
                    let website = window.location.origin + '/wp-json/integrated/forgot_password';
                    jQuery.ajax({
                        type: 'POST',
                        url: website,
                        data: {
                            email_address: document.getElementById('forgot_email').value
                        },
                        success: function (result) {
                            if(result === true) {
                                that.swap_views(forgot_password, password_sent) 
                            } else {
                                login_pristine.addError(password, result.message);
                                console.log(result);
                            }

                            that.activate_button(reset_password_button);
                        },
                        error: function(result) {
                            console.log("Failed to login: ", result);
                            try {
                                // login_pristine.addError(document.getElementById('forgot_email'), result.responseJSON.data.params.email_address);
                                login_pristine.addError(document.getElementById('forgot_email'), result.responseJSON.message);
                            } catch (e) {

                            }

                            that.activate_button(reset_password_button);
                        }
                    })
                    
                } else {
                    that.activate_button(reset_password_button);
                }
            })
        }

        if(back_to_login_button) {
            back_to_login_button.addEventListener('click', (e) => { 
                e.preventDefault();
                this.swap_views(forgot_password, login) 
            })
        }

        if(password_sent_button) {
            password_sent_button.addEventListener('click', (e) => { 
                e.preventDefault();
                this.swap_views(password_sent, login)
            })
        }

        let login_form = document.getElementById('login_form');

        if(login_form) {
            var login_pristine = new Pristine(login_form, {
                classTo: 'registration-input',
                errorClass: 'invalid',
                successClass: 'valid',
                errorTextParent: 'registration-input',
                errorTextTag: 'p',
                errorTextClass: 'registration-input__validation'
            }, false);

            login_pristine.addValidator()

            let login_button = document.getElementById('login-button');
            let that = this;

            login_button.addEventListener('click', (e) => {
                e.preventDefault();
                that.deactivate_button(login_button);

                var email_address = document.getElementById('login_email');
                var password = document.getElementById('login_password');
                
                let validate = login_pristine.validate();

                let website = window.location.origin + '/wp-json/integrated/login';

                if(validate) {
                    jQuery.ajax({
                        type: 'POST',
                        url: website,
                        data: {
                            email_address: email_address.value,
                            password: password.value
                        },
                        success: function (result) {
                            if(!result.code && result.success == true) {
                                console.log(result.message);
                                // that.showNext(stage_3, stage_4);
                                // that.login();
                                location.reload();
                            } else {
                                if(result.code) {
                                    console.log("Code: " + result.code);
                                }

                                console.log("Message: " + result.message)
                                login_pristine.addError(password, result.message);

                                if(result.data) {
                                    console.log("Data: " + result.data);
                                }
                            }

                            that.activate_button(login_button);
                            // that.set_posts(JSON.parse(result))
                        },
                        error: function(result) {
                            console.log("Failed to login: ", result);
                            try {
                                login_pristine.addError(email_address, result.responseJSON.data.params.email_address)
                            } catch (e) {

                            }

                            that.activate_button(login_button);
                        }
                    });
                } else {
                    that.activate_button(login_button);
                }
            })  
        }
    },

    swap_views(this_view, next_view) {
        console.log("This view: ", this_view)
        console.log("next view: ", next_view)
        if(this_view && next_view) {
            this_view.style.display = 'none';
            next_view.style.display = 'block';
            window.scrollTo(0, 0);
            this.lock_scroll()
        }
    },

    // login() {
    //     document.body.style.height = 'auto';
    //     document.body.style.overflow = 'visible';
    //     //unlock the scroll when the user logs in.
    //     $(document).unbind('scroll'); 
    //     // $('body').css({'overflow':'visible'});
    //     document.getElementById('register-modal').style.display = "none";
    // },
    lock_scroll() {
        if(navigator.userAgent.indexOf('MSIE')!==-1
        || navigator.appVersion.indexOf('Trident/') > -1){
        /* Microsoft Internet Explorer detected in. */
            window.addEventListener('scroll', () => {
                window.scrollTo(0, 0);
            });
            console.log("Disabling scroll on IE");
        } else {
            console.log("Not IE11");
            disablePageScroll();
        }
        // $('body').css({'overflow':'hidden'});
        // $(document).bind('scroll',function () { 
        //     window.scrollTo(0,0); 
        // });
    },
    deactivate_button(button) {
        button.disabled = true;
        button.querySelector('span').innerHTML = "Submitting"
        // button.style.backgroundColor = 'red';
        // button.style.display = "none";
    },
    activate_button(button) {
        button.disabled = false;
        button.querySelector('span').innerHTML = "Continue"
        // button.style.backgroundColor = 'orange';
    }
}